<template>
  <section class="supplier-detail-operation-tab">
    <article class="customer-detail-card customer-detail-card--accent-primary">
      <ExpenseFeeToolbar
        class="supplier-detail-operation-toolbar"
        :filter-options="filterOptions"
        :search-placeholder="text.detail.expensesTab.toolbar.searchPlaceholder"
        inline-filter-key="expense_class"
        :first-row-keys="['category', 'tags']"
        :second-row-keys="['has_xml', 'currency']"
        :filter-configs="toolbarFilterConfigs"
        :all-option-labels="toolbarAllOptionLabels"
        :selection-all-labels="toolbarSelectionAllLabels"
        :empty-option-text="text.detail.expensesTab.toolbar.emptyOption"
        :filters-button-title="text.detail.expensesTab.toolbar.filtersButtonTitle"
        :search-button-title="text.detail.expensesTab.toolbar.searchButtonTitle"
        :date-range-presets="toolbarDateRangePresets"
        initial-preset-key=""
        :first-row-columns="2"
        :second-row-columns="2"
        @search-change="$emit('search-change', $event)"
        @filters-change="$emit('filters-change', $event)"
      />

      <StatusTabs
        class="supplier-detail-operation-status-tabs"
        :tabs="statusTabs"
        :active-tab="activeStatusTab"
        @select="$emit('status-tab-select', $event)"
      />

      <SaleSharedExpensesTable
        :rows="rows"
        :loading="loading"
        :empty-text="emptyText"
        :pagination="pagination"
        :show-business-column="true"
        :show-provider-column="false"
        @page-change="$emit('page-change', $event)"
        @pay-expense="$emit('pay-expense', $event)"
        @edit-expense="$emit('edit-expense', $event)"
        @delete-expense="$emit('delete-expense', $event)"
        @approve-expense="$emit('approve-expense', $event)"
        @download-xml="$emit('download-xml', $event)"
        @download-pdf="$emit('download-pdf', $event)"
        @download-receipt="$emit('download-receipt', $event)"
      />
    </article>
  </section>
</template>

<script>
import ExpenseFeeToolbar from '@/components/expensesFees/ExpenseFeeToolbar.vue';
import StatusTabs from '@/components/common/StatusTabs.vue';
import SaleSharedExpensesTable from '@/components/sales/shared/expenses/SaleSharedExpensesTable.vue';
import { useDomainText } from '@/composables/text/useDomainText';

const { catalog: text } = useDomainText('sales');

export default {
  name: 'SupplierDetailExpensesTab',
  components: {
    ExpenseFeeToolbar,
    StatusTabs,
    SaleSharedExpensesTable,
  },
  props: {
    rows: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    filterOptions: {
      type: Object,
      default: () => ({}),
    },
    pagination: {
      type: Object,
      default: () => ({
        current_page: 1,
        per_page: 30,
        total_pages: 1,
        total_items: 0,
      }),
    },
    statusTabs: {
      type: Array,
      default: () => [],
    },
    activeStatusTab: {
      type: String,
      default: 'all',
    },
    emptyText: {
      type: String,
      default: text.detail.expensesTab.table.empty,
    },
  },
  emits: [
    'search-change',
    'filters-change',
    'status-tab-select',
    'page-change',
    'pay-expense',
    'edit-expense',
    'delete-expense',
    'approve-expense',
    'download-xml',
    'download-pdf',
    'download-receipt',
  ],
  data() {
    return {
      text,
      toolbarDateRangePresets: text.detail.expensesTab.toolbar.dateRangePresets,
      toolbarAllOptionLabels: text.detail.expensesTab.toolbar.allOptionLabels,
      toolbarSelectionAllLabels: text.detail.expensesTab.toolbar.selectionAllLabels,
      toolbarFilterConfigs: [
        {
          key: 'expense_class',
          label: text.detail.expensesTab.toolbar.filters.expenseClass.label,
          placeholder: text.detail.expensesTab.toolbar.filters.expenseClass.placeholder,
          searchable: text.detail.expensesTab.toolbar.filters.expenseClass.searchable,
        },
        {
          key: 'category',
          label: text.detail.expensesTab.toolbar.filters.category.label,
          placeholder: text.detail.expensesTab.toolbar.filters.category.placeholder,
          searchable: text.detail.expensesTab.toolbar.filters.category.searchable,
        },
        {
          key: 'tags',
          label: text.detail.expensesTab.toolbar.filters.tags.label,
          placeholder: text.detail.expensesTab.toolbar.filters.tags.placeholder,
          searchable: text.detail.expensesTab.toolbar.filters.tags.searchable,
        },
        {
          key: 'has_xml',
          label: text.detail.expensesTab.toolbar.filters.hasXml.label,
          placeholder: text.detail.expensesTab.toolbar.filters.hasXml.placeholder,
          searchable: text.detail.expensesTab.toolbar.filters.hasXml.searchable,
        },
        {
          key: 'currency',
          label: text.detail.expensesTab.toolbar.filters.currency.label,
          placeholder: text.detail.expensesTab.toolbar.filters.currency.placeholder,
          searchable: text.detail.expensesTab.toolbar.filters.currency.searchable,
        },
      ],
    };
  },
};
</script>

<style scoped>
.supplier-detail-operation-tab {
  display: grid;
  gap: 12px;
}

.supplier-detail-operation-toolbar,
.supplier-detail-operation-status-tabs {
  margin: 0;
}

.supplier-detail-operation-status-tabs {
  margin-top: 10px;
}

.supplier-detail-operation-status-tabs :deep(.sales-status-tabs) {
  margin-top: 0;
}
</style>
